import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IssueService } from '../../../../services/issue.service';

@Component({
    selector: 'metering-issues-summary-grid-item',
    templateUrl: './metering-issues-summary-grid-item.component.html'
})
export class MeteringIssuesSummaryGridItemComponent implements AfterViewInit, OnDestroy {

    clientId: number;
    numberOfConsumerWithIssues: number;
    numberOfIssues: number;
    mtrIssuesLastMonth: number;
    issuesVariation: number;
    subscriptions: any[] = [];
    isDecreasing: boolean = false;
    isIncreasing: boolean = false;


    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngAfterViewInit() {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.issueService.getConsumptionSummary(this.clientId).then((result) => { // change to metering summary
            let res = result as any;
            this.numberOfConsumerWithIssues = res.numberofConsumersExperiencingIssues != null ? res.numberofConsumersExperiencingIssues : 0;
            this.numberOfIssues = res.numberOfIssues != null ? res.numberOfIssues : 0;
            this.mtrIssuesLastMonth = res.mtrIssuesLastMonth != null ? res.mtrIssuesLastMonth : 0;
            this.isIncreasing = this.mtrIssuesLastMonth > this.numberOfIssues ? true : false;
            this.isDecreasing = this.mtrIssuesLastMonth < this.numberOfIssues ? true : false;
            this.issuesVariation = this.mtrIssuesLastMonth - this.numberOfIssues;
        }).catch(reason => {
            this.numberOfConsumerWithIssues = 0;
            this.numberOfIssues = 0;
            this.issuesVariation = 0;
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
